import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';

import { translate as t } from '../../lib/I18n';
import connectToStores from '../../helpers/connectToStores';
import FavouritesStore from '../../stores/FavouritesStore';
import UserStore from '../../stores/UserStore';
import FeatureFlagStore from "../../stores/FeatureFlagStore";
import FavouritesActions from '../../actions/FavouritesActions';
import User from '../../records/User';

import PureRenderComponent from '../PureRenderComponent';
import Icon from '../general/Icon';
import FavouritesModal from '../favourites/FavouritesModal';

export class FavouritesLink extends PureRenderComponent {

    static propTypes = {
        favourites: PropTypes.instanceOf(List).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        enabled: PropTypes.bool.isRequired
    };

    static defaultProps = {
        favourites: new List(),
        enabled: false
    };

    state = {
        showFavouritesModal: false
    };

    UNSAFE_componentWillMount() {
        const { enabled, user } = this.props;
        if (enabled && user.isLoggedIn()) {
            FavouritesActions.getAll(user);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { enabled, user } = nextProps;
        if (enabled && user.isLoggedIn() && this.isUserChanged(user, this.props.user)) {
            FavouritesActions.getAll(user);
        }
    }

    isUserChanged(user, oldUser) {
        return user.id !== oldUser.id;
    }

    _toggleModal = () => this.setState({ showFavouritesModal: !this.state.showFavouritesModal });

    render() {
        const { favourites, enabled, user } = this.props;

        if (favourites.isEmpty() || !enabled || !user.isLoggedIn()) {
            return null;
        }

        return (
            <li className="pull-right nav-list__item nav-list__item--favourites">
                <div>
                    <button type="button" className="navlink__favourites btn" role="link"
                            aria-label={ t('ariaLabel.openFavourites') }
                            onClick={ this._toggleModal } >
                        <Icon icon="favourite"/>
                        <span className="hidden-mobile hidden-tablet-portrait">&nbsp;{ t('header.favourites') }</span>
                    </button>
                    { this.state.showFavouritesModal &&
                        <FavouritesModal
                            favourites={ favourites }
                            onCancel={ this._toggleModal }
                            user={ user }/> }
                </div>
            </li>
        );
    }
}

export default connectToStores([ FavouritesStore, UserStore, FeatureFlagStore ], () => ({
    favourites: FavouritesStore.getFavourites(),
    user: UserStore.getCurrent(),
    enabled: FeatureFlagStore.get('enableFavouriteTickets')
}))(FavouritesLink);
